class OmoMobileFooter extends HTMLElement {
  constructor() {
    super();
    this.mobileMedia = window.matchMedia('(max-width: 989px)');
  }

  connectedCallback() {
    this.controls = [...this.querySelectorAll('[data-omo-footer-control]')];
    this.panels = [...this.querySelectorAll('[data-omo-footer-panel]')];
    this.onMediaChange = (event) => {
      if (!event.matches) this.closeAll();
    };

    this.controls.forEach((control) => {
      control.addEventListener('click', () => this.togglePanel(control));
    });
    this.mobileMedia.addEventListener('change', this.onMediaChange);
  }

  disconnectedCallback() {
    this.mobileMedia.removeEventListener('change', this.onMediaChange);
  }

  togglePanel(control) {
    if (!this.mobileMedia.matches) return;

    const panel = this.panels.find((item) => item.dataset.omoFooterPanel === control.dataset.omoFooterControl);
    if (!panel) return;

    const shouldOpen = control.getAttribute('aria-expanded') !== 'true';
    this.closeAll();
    if (!shouldOpen) return;

    control.setAttribute('aria-expanded', 'true');
    control.classList.add('is-active');
    panel.inert = false;
    panel.setAttribute('aria-hidden', 'false');
    panel.classList.add('is-active');
  }

  closeAll() {
    this.controls.forEach((control) => {
      control.setAttribute('aria-expanded', 'false');
      control.classList.remove('is-active');
    });
    this.panels.forEach((panel) => {
      panel.classList.remove('is-active');
      panel.setAttribute('aria-hidden', 'true');
      panel.inert = true;
    });
  }
}

if (!customElements.get('omo-mobile-footer')) {
  customElements.define('omo-mobile-footer', OmoMobileFooter);
}
